import { useEffect, useState } from 'react';
import { desktop, openExternal, webStoreUrl } from '../platform';
import { useAppUpdate } from '../state/update';
import { IconDownload, IconRefresh } from './icons';

/**
 * Desktop only: a new version of the app is downloading, or ready to restart into, or (an
 * unsigned Mac copy, which can't update itself) waiting on the download page.
 */
export function UpdateBanner() {
  const [update] = useAppUpdate();
  // "Later" hides this version only; a newer one shows the banner again.
  const [laterFor, setLaterFor] = useState<string | null>(null);
  const [restarting, setRestarting] = useState(false);
  useEffect(() => {
    if (update?.status !== 'ready') setRestarting(false);
  }, [update?.status]);

  if (update?.status === 'available' && laterFor !== update.version) {
    return (
      <div className="container" style={{ marginTop: 16 }}>
        <div className="notice update-banner row between wrap">
          <span>
            <IconDownload size={16} /> <strong>Version {update.version} of the app is out.</strong> This copy can't update itself: download the new version and install it over this one.
          </span>
          <div className="row" style={{ gap: 6 }}>
            <button className="btn btn-sm btn-ghost" onClick={() => setLaterFor(update.version ?? '')}>Later</button>
            <button className="btn btn-sm btn-primary" onClick={() => openExternal(webStoreUrl('/download'))}>Download</button>
          </div>
        </div>
      </div>
    );
  }
  if (update?.status === 'downloading') {
    return (
      <div className="container" style={{ marginTop: 16 }}>
        <div className="notice update-banner row between wrap">
          <span>
            <IconDownload size={16} /> Downloading version {update.version} of the VA Plugin Store app… {update.percent ? `${update.percent}%` : ''}
          </span>
        </div>
      </div>
    );
  }
  if (update?.status === 'ready' && laterFor !== update.version) {
    return (
      <div className="container" style={{ marginTop: 16 }}>
        <div className="notice update-banner row between wrap">
          <span>
            <IconRefresh size={16} /> <strong>Version {update.version} of the app is ready.</strong> Restart to update, or it updates the next time you quit the app.
          </span>
          <div className="row" style={{ gap: 6 }}>
            <button className="btn btn-sm btn-ghost" onClick={() => setLaterFor(update.version ?? '')}>Later</button>
            <button
              className="btn btn-sm btn-primary"
              disabled={restarting}
              onClick={() => {
                setRestarting(true);
                void desktop?.updates.install();
              }}
            >
              {restarting ? 'Restarting…' : 'Restart now'}
            </button>
          </div>
        </div>
      </div>
    );
  }
  return null;
}
